window.addEventListener("DOMContentLoaded", () => {

    let searchInputBoxSelector = document.querySelectorAll(".st-search-bar .st-search-bar-inner #st-search-box, .st-search-box input[name='q']");

    searchInputBoxSelector.forEach((searchInputBox) => {
        if (searchInputBox) {
            searchInputBox.setAttribute("placeholder", "");
            const placeHolderPhrases = [
                "Search For Sunscreen",
                "Search For Moisturizer",
            ];

            let index = 0;
            let typingTimer;
            const updatePlaceHolder = function () {
                const phrase = placeHolderPhrases[index];
                const length = phrase.length;
                let queryIndex = 0;
                typingTimer = setInterval(function () {
                    if (queryIndex === length) {
                        setTimeout(erasePlaceHolder, 1000);

                        clearInterval(typingTimer);
                    } else {
                        const currentPlaceholderValue =
                            searchInputBox.getAttribute("placeholder");

                        searchInputBox.setAttribute(
                            "placeholder",
                            currentPlaceholderValue + phrase.charAt(queryIndex)
                        );

                        queryIndex++;
                    }
                }, 100);
            };

            const erasePlaceHolder = function () {
                const currentPlaceholderValue =
                    searchInputBox.getAttribute("placeholder");
                const length = currentPlaceholderValue.length;
                let queryIndex = length - 1;
                typingTimer = setInterval(function () {
                    if (queryIndex === -1) {
                        clearInterval(typingTimer);
                        index++;
                        if (index === placeHolderPhrases.length) {
                            index = 0;
                        }
                        setTimeout(updatePlaceHolder, 1000);
                    } else {
                        const newPlaceholderValue = currentPlaceholderValue.slice(
                            0,
                            queryIndex
                        );
                        searchInputBox.setAttribute("placeholder", newPlaceholderValue);
                        queryIndex--;
                    }
                }, 50);
            };
            updatePlaceHolder();
        }
    });
});

let createCartPromise = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return fetch(`${baseUrl}/cart.js`).then(res => res.json());
};


window.stCustomAddToCart = (id) => {
  document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
  
  let bundleSections = [];

  document.dispatchEvent(new CustomEvent("cart:push:section.id", {
    bubbles: true,
    detail: { sections: bundleSections }
  }));

  const productElement = document.querySelector(`.st-product-card[data-st-product-activevariant-id="${id}"]`);
  if (!productElement) {
    console.warn("Product element not found for variant ID:", id);
    return;
  }

  let add_to_cart_element = productElement.querySelector(".st-atc-btn");
  if(add_to_cart_element){
    add_to_cart_element.classList.add("loader");
  }
  let addToCart = add_to_cart_element.innerHTML;
  const productId = productElement.getAttribute('data-st-product-id');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const url = `${baseUrl}/cart/add.js`;
  const formData = new FormData();

  formData.append("form_type", "product");
  formData.append("utf8", "✓");
  formData.append("id", id);
  formData.append("product-id", productId);
  formData.append("quantity", 1);
  formData.append("section-id", "template--20382674616545__main");
  formData.append("sections", bundleSections.join(","));

  fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/javascript",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: formData
  })
    .then(response => {
      if (!response.ok) throw new Error(response.statusText);
      return response.json().then(data => ({ ok: response.ok, data }));
    })
    .then(({ ok, data }) => {
      document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));

      if (ok) {
        createCartPromise().then((cart) => {
          cart.sections = data.sections;
          const items = data.hasOwnProperty("items") ? data.items : [data];
          const actionAfterATC = formData.get("action_added");
          document.dispatchEvent(new CustomEvent("variant:add", {
            bubbles: true,
            detail: { items, actionAfterATC, cart }
          }));
          document.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: "variant:add", actionAfterATC, cart }
          }));
          if (typeof Shopify !== 'undefined' && typeof Shopify.cartContractual === 'function') {
            Shopify.cartContractual(cart);
          } else {
            console.warn('Shopify.cartContractual not found.');
          }
          if (typeof Shopify !== 'undefined' && typeof Shopify.highValueCartAlert === 'function') {
            Shopify.highValueCartAlert(cart);
          }
        });
      }
    })
    .catch(error => {
      console.error("Add to cart failed:", error);
    })
    .finally(() => {
        if (add_to_cart_element) {
        add_to_cart_element.classList.remove("loader");
        add_to_cart_element.innerHTML = addToCart;
    }
});
};
